import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  CardActions
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

const ReportCard = ({ title, description, icon, path, color = '#1976d2', onPageChange }) => {
  const handleClick = () => {
    if (path && onPageChange) {
      onPageChange(path);
    }
  };

  return (
    <Card 
      sx={{ 
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'all 0.3s ease-in-out',
        border: `1px solid ${color}20`,
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: `0 8px 25px ${color}40`,
          border: `1px solid ${color}40`
        }
      }}
    >
      <CardContent sx={{ flexGrow: 1, p: 3 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: 2,
              p: 1.5,
              color: color
            }}
          >
            {icon}
          </Box>
        </Box>
        
        <Typography 
          variant="h6" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontWeight: 600,
            color: 'text.primary'
          }}
        >
          {title}
        </Typography>
        
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ mb: 2 }}
        >
          {description}
        </Typography>
      </CardContent>
      
      <CardActions sx={{ p: 2, pt: 0 }}>
        <Button
          size="small"
          endIcon={<ArrowForward />}
          onClick={handleClick}
          sx={{
            color: color,
            fontWeight: 600,
            '&:hover': {
              backgroundColor: `${color}10`
            }
          }}
        >
          View Report
        </Button>
      </CardActions>
    </Card>
  );
};

export default ReportCard;